new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: '',
        // Buy button visibility tracking
        buyButtonWasVisible: false // Variável para controlar se o botão já foi visto pelo menos uma vez
    },
    methods: {
        getInfo(event, id) {
            axios.get(`/api/front/product/${id}/get-linked-product/`)
                .then(res => {
                    const actualElement = event.target;
                    if ($('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').length) {
                        $('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').remove();
                    }
                    actualElement.closest('.product-item-kit').querySelector('.is-selected')?.classList.remove('is-selected');
                    actualElement.closest('.product-item-kit').querySelector('.is-selected')?.classList.add('is-selected');
                    actualElement.closest('.product-item-kit').setAttribute('data-product-item-kit-id', res.data.id);
                    actualElement.closest('.product__colors-item').classList.add('is-selected');
                    actualElement.closest('.product-item-kit').querySelector('.name span').innerHTML = `${res.data.name}`;
                    actualElement.closest('.product-item-kit').querySelector('.name img').src = `${res.data.thumbnail}`;
                    const actualVariations = actualElement.closest('.product-item-kit').nextElementSibling;
                    actualVariations.innerHTML = '<p class="label_attributes">Selecione o tamanho</p>';
                    var sizes = [];
                    for (i = 0; i <= res.data.variations.length - 1; i++) {
                        if (res.data.variations[i].main_attribute != null) {
                            sizes.splice(res.data.variations[i].main_attribute.order, 0, res.data.variations[i]);
                        }
                    }
                    for (i = 0; i <= sizes.length - 1; i++) {
                        if (sizes[i].main_attribute != null) {
                            var randomNumber = Math.floor(Math.random() * 99999999);
                            var stock = sizes[i].available == false ? 'out-of-stock' : '';
                            actualVariations.insertAdjacentHTML('beforeend', `<input type="radio" name="product_item_variation__product_detail__${res.data.id}_${randomNumber}" id="product_item_variation__product_detail__${sizes[i].id}_${randomNumber}" value="${sizes[i].id}" data-id-auto="" data-variation-name="${sizes[i].main_attribute.name}" data-origin-location="product_detail"><label for="product_item_variation__product_detail__${sizes[i].id}_${randomNumber}" class="label_radio ${stock} radio"><span>${sizes[i].main_attribute.value}</span></label>`);
                        }
                    }
                    if (res.data.addons.length) {
                        var complements = document.createElement('div');
                        complements.setAttribute('id', `js-product_addons__product_detail_${id}`);
                        complements.setAttribute('class', 'complements');
                        complements.setAttribute('complements-for', `${id}`);
                        complements.innerHTML = '<h2 class="complements-title">Complementos:</h2><br>';
                        for (i = 0; i <= res.data.addons.length - 1; i++) {
                            var optional = res.data.addons[i].is_required == false ? 'True' : 'False';
                            var addonPrice = res.data.addons[i].price ? res.data.addons[i].price : '';
                            complements.insertAdjacentHTML('beforeend', `<label class="complements-label-${res.data.addons[i].id}" addon-id="${res.data.addons[i].id}" addon-price="${addonPrice}" for="addon-${res.data.addons[i].id}" data-addon-is-optional="${optional}">${res.data.addons[i].field_label}</label>`);
                            if (res.data.addons[i].field_type == "radio_options") {
                                var complementsSelect = document.createElement('select');
                                complementsSelect.setAttribute('name', `addon-${res.data.addons[i].id}`);
                                complementsSelect.setAttribute('id', `addon-select-${res.data.addons[i].id}`);
                                for (j = 0; j <= res.data.addons[i].field_options.length - 1; j++) {
                                    complementsSelect.add(new Option(`${res.data.addons[i].field_options[j]}`, `${res.data.addons[i].field_options[j]}`));
                                }
                                var selectDiv = document.createElement('div');
                                selectDiv.setAttribute('class', 'complements-content');
                                $(selectDiv).append(complementsSelect);
                                $(complements).append(selectDiv);
                            } else if (res.data.addons[i].field_type == "text") {
                                var selectDiv = document.createElement('div');
                                selectDiv.setAttribute('class', 'complements-content-area');
                                $(selectDiv).append(`<input name="addon-${res.data.addons[i].id}" type="${res.data.addons[i].field_type}" maxlength="${res.data.addons[i].field_char_limit}"></div>`);
                                $(complements).append(selectDiv);
                            }
                        }
                        $('.kitcolors').closest('.itens-for-carousel').append(complements);
                    }
                    $('.kitcolors').height($('.kitcolors').closest('.itens-for-carousel').outerHeight());
                    $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').on('change', function () {
                        $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').not(this).prop('checked', false);
                    });
                    if (window.outerWidth <= 991) {
                        var slickSlider = $('.product-detail__header--photoArea-mobile');

                        if (slickSlider.hasClass('slick-initialized')) {
                            slickSlider.slick('slickRemove', null, null, true);
                        } else {
                            slickSlider.slick();
                        }

                        for (i = 0; i < res.data.images.length; i++) {
                            slickSlider.slick('slickAdd', `<li><a href="${res.data.images[i]}" data-fancybox="gallery3"><img class="product-detail__header--photoArea-mobile-img" src="${res.data.images[i]}" width="100%"></a></li>`);
                        }

                        slickSlider.slick('slickGoTo', 1);
                    } else {
                        const noThumbs = document.querySelector('#product-photo');
                        if (noThumbs) {
                            var noThumbsUl = document.querySelector('#product-photo ul');
                            var miniThumbs = document.querySelector('.product-detail__header--photoArea-thumbs-default .default-thumbs');

                            // Remova todos os spans dentro do noThumbsUl
                            while (noThumbsUl.firstChild) {
                                noThumbsUl.removeChild(noThumbsUl.firstChild);
                            }
                            while (miniThumbs.firstChild) {
                                miniThumbs.removeChild(miniThumbs.firstChild);
                            }

                            for (i = 0; i <= res.data.images.length - 1; i++) {
                                var li = document.createElement('li');
                                li.innerHTML = `<a href="${res.data.images[i]}" data-fancybox="gallery1"><img src="${res.data.images[i]}" width="100%"></a>`;
                                noThumbsUl.appendChild(li);

                                var liMini = document.createElement('li');
                                liMini.setAttribute('class', 'sp-wrap');
                                liMini.innerHTML = `<img src="${res.data.images[i]}" width="100%">`;
                                miniThumbs.appendChild(liMini);
                            }

                            document.querySelectorAll('.product-detail__header--photoArea-thumbs-default li').forEach((thumb, index) => {
                                thumb.addEventListener('click', () => {
                                    const targetLi = document.querySelectorAll('#product-photo li')[index];
                                    if (targetLi) {
                                        targetLi.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    }
                                });
                            });

                        } else {
                            $('.sp-wrap').each(function () {
                                $(this).closest('.slick-slide').remove();
                            });
                            for (i = 0; i <= res.data.images.length - 1; i++) {
                                $('.sp-thumbs').slick('slickAdd', `<div><a class="sp-wrap" href="${res.data.images[i]}" style="background-image: url(${res.data.images[i]}); width: 100%; display: inline-block;" tabindex="0" data-video="undefined"><img src="${res.data.images[i]}" width="100%"></a></div>`, i);
                                if (i == 0) {
                                    document.querySelector('.sp-wrap').click();
                                }
                            }
                        }
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if (contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img');

                    if (photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');

                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                                content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }

                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                                activeTab(index);
                            });
                        });
                    }
                }
            }

            if (photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 5,
                        vertical: true,
                        slidesToScroll: 1
                    });
                }
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },
        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },
        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },
        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const otherElement = document.querySelector(".product-detail__fixed--buy");
            if (!buyButton || !otherElement) return;

            // Ponto em que o usuário "passou" do botão
            const buttonEnd = buyButton.offsetTop + buyButton.offsetHeight;

            if (window.scrollY > buttonEnd) {
                otherElement.classList.add("active");
            } else {
                otherElement.classList.remove("active");
            }
        },
        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },
        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        this.resizeThumbs();
        this.clickThumbs();

        // Esconde o less-stock inicialmente
        const initialLessStock = document.querySelectorAll('.less-stock');
        initialLessStock.forEach(element => {
            element.style.display = 'none';
        });

        const attributes = document.querySelector('.product-detail__attributes');
        if (attributes) {
            attributes.addEventListener('click', function () {
                this.classList.toggle('active');
            });
        }

        let navTab = document.querySelector('.product-detail__nav');
        let nav = document.querySelector('.product-detail__nav-tab');
        let navItem = nav ? nav.querySelectorAll('.nav-item') : [];
        let navContent = document.querySelector('.product-detail__nav-content');
        let navShow = navContent ? navContent.querySelectorAll('.nav-show') : [];

        if (navTab && navItem.length && navShow.length) {
            navItem = Array.from(navItem);
            navShow = Array.from(navShow);

            navItem[0].classList.add('active');
            navShow[0].classList.add('active');

            function activeTab(index) {
                navShow.forEach((content) => {
                    content.classList.remove('active');
                });
                navItem.forEach((item) => {
                    item.classList.remove('active');
                });
                navShow[index].classList.add('active');
                navItem[index].classList.add('active');
            }

            navItem.forEach((itemMenu, index) => {
                itemMenu.addEventListener('click', () => {
                    const isActive = itemMenu.classList.contains('active');

                    // Se já estiver ativo, desativa
                    if (isActive) {
                        itemMenu.classList.remove('active');
                        navShow[index].classList.remove('active');
                    } else {
                        activeTab(index);
                    }
                });
            });
        }

        let description = document.querySelector('.description');
        if (description) {
            let navTab = Array.from(description.querySelectorAll('.description-title'));
            let navShow = Array.from(description.querySelectorAll('.description-content'));

            if (navTab.length && navShow.length) {
                function toggleTab(index) {
                    const isActive = navTab[index].classList.contains('active');

                    // Remove 'active' de todos
                    navTab.forEach(item => item.classList.remove('active'));
                    navShow.forEach(content => content.classList.remove('active'));

                    // Se o item clicado não estava ativo, ativa ele
                    if (!isActive) {
                        navTab[index].classList.add('active');
                        navShow[index].classList.add('active');
                    }
                }

                navTab.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', () => toggleTab(index));
                });
            }
        }

        const allSizesLabel = document.querySelectorAll('label[for^="product_item_variation__product_detail_');
        if (allSizesLabel) {
            allSizesLabel.forEach(label => {
                label.addEventListener('click', () => {
                    const inputId = label.getAttribute('for');
                    if (inputId) {
                        const container = document.querySelector('.product-detail__fixed--buy');
                        if (container) {
                            const inputsInContainer = container.querySelectorAll('input.clicou');
                            inputsInContainer.forEach(input => {
                                input.classList.remove('clicou');
                            });
                        }

                        const allInputs = document.querySelectorAll(`input[id^="${inputId}"]`);

                        if (allInputs) {
                            allInputs.forEach(input => {
                                input.classList.add('clicou');
                            })
                        }

                    }
                });
            })
        }

        waitForElementToExist('.price-cupom').then(element => {
            const priceCupom = document.querySelector('.price-cupom b');

            if (priceCupom) {
                const priceCupomValue = priceCupom.textContent;

                if (priceCupomValue) {
                    let newValue = priceCupomValue;

                    if (priceCupom) {
                        priceCupom.addEventListener("click", (e) => {
                            e.preventDefault();

                            navigator.clipboard.writeText(newValue).then(() => {
                                alert("Valor copiado: " + newValue);
                            }).catch(err => {
                                console.error('Erro ao copiar: ', err);
                                alert("Erro ao copiar o valor.");
                            });
                        });
                    }
                }
            }
        });

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
            if (newValue) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.removeProperty('overflow');
            }
        },
    }
})

$(document).ready(function () {

    ; (function hideEmptyAttributeContainers() {
        const selectors = ['.product-detail__attributes', '.attributes-fixed'];
        selectors.forEach(selector => {
            const el = document.querySelector(selector);
            if (!el) return;
            if (!el.querySelector('ul li')) {
                el.style.display = 'none';
            }
        });
    })()

    function changeAddTogetherTitle() {
        const el = document.querySelector('#add-together__template');
        if (!el) return false;
        const title = el.querySelector('.add-together__template--title');
        if (!title) return false;
        title.textContent = 'Complete o look com:';
        return true;
    }

    if (!changeAddTogetherTitle()) {
        const observer = new MutationObserver(function (_mutations, obs) {
            if (changeAddTogetherTitle()) {
                obs.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.querySelector(".carousel-kit")) {
        var splide = new Splide('.carousel-kit', {
            type: "slide",
            height: 'auto', // Isso aqui ativa o adaptive height
            autoHeight: true,
            autoplay: false,
            rewind: false,
            arrows: false,
            speed: 800,
            perPage: 1,
            perMove: 1,
            drag: false,
            pauseOnFocus: false,
            pagination: false,
            breakpoints: {
                768: {
                    drag: false,
                },
            },
        });

        splide.on('mounted', function () {
            var totalSlides = splide.length;
            var nextButton = document.querySelector('.carousel-kit-next');
            nextButton.setAttribute('data-end', totalSlides - 1);

            var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
            addToCartButton.classList.add('no-buy');

            var countDisplay = document.querySelector('.carousel-count');
            countDisplay.textContent = '1/' + totalSlides;
        });

        splide.mount();

        var nextButton = document.querySelector('.carousel-kit-next');
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-actual') {
                    var actual = parseInt(nextButton.getAttribute('data-actual'));
                    var end = parseInt(nextButton.getAttribute('data-end'));

                    if (actual === end) {
                        nextButton.classList.add('no-click');
                    } else {
                        nextButton.classList.remove('no-click');
                    }
                }
            });
        });

        // Configurar o observer para monitorar mudanças no atributo data-actual
        observer.observe(nextButton, {
            attributes: true,
            attributeFilter: ['data-actual']
        });
        var prevButton = document.querySelector('.carousel-kit-prev');
        var message = document.querySelector('.carousel-message');
        var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
        var countDisplay = document.querySelector('.carousel-count');

        nextButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end) {
                var activeSlide = document.querySelector('.splide__slide.is-active');
                var radioChecked = activeSlide.querySelector('.product-radio-variation input[type="radio"]:checked');
                var noVariations = activeSlide.querySelector('.js_product_item_kit').getAttribute('data-no-variations');

                if (radioChecked || noVariations) {
                    splide.go('>');
                    actual = Math.min(actual + 1, end);
                    nextButton.setAttribute('data-actual', actual);
                    message.classList.remove('show');
                } else {
                    message.classList.add('show');
                }
            }
        });

        prevButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end && actual > 0) {
                splide.go('<');
                actual = Math.max(actual - 1, 0);
                nextButton.setAttribute('data-actual', actual);
            }
        });

        splide.on('move', function () {
            var i = splide.index + 1;
            countDisplay.textContent = i + '/' + splide.length;
        });
    }

    waitForElementToExist('.content-product-detail .faixa-comunicado').then(element => {
        $('.faixa-comunicado').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 1000,
            mobileFirst: true,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: false,
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    }
                },
            ]
        });
    });

    if ($('.mobile-slider .slider-single') && $('.mobile-slider .slider-nav')) {
        $('.mobile-slider .slider-single').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            fade: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });

        $('.mobile-slider .slider-nav').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            slidesToShow: 4, // ou quantas thumbs quiser mostrar
            slidesToScroll: 1,
            asNavFor: '.slider-single',
            focusOnSelect: true,
            centerMode: false, // opcional
            arrows: false, // ou false se quiser ocultar as setas
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if (window.matchMedia("(min-width: 992px)").matches) {
        function animeScroll() {
            const photoScroll = document.querySelector('.product-detail__header--photoArea-photo ul');
            const sidebarInner = document.querySelector('.default-thumbs');

            if (photoScroll && sidebarInner && photoScroll.offsetHeight > sidebarInner.offsetHeight) {
                const sidebarInnerHeight = sidebarInner.offsetHeight;
                const totalHeight = photoScroll.offsetHeight - sidebarInnerHeight;
                const pageTop = window.pageYOffset;
                const rect = photoScroll.getBoundingClientRect();
                const offsetTop = rect.top + pageTop; // Calculate the distance from top of the page to the photoScroll

                if (pageTop > (offsetTop + totalHeight)) {
                    $('.default-thumbs').css({ position: 'relative', top: totalHeight + 'px', maxWidth: '100%' });
                } else if (pageTop > offsetTop) {
                    $('.default-thumbs').css({ position: 'fixed', top: '0px', maxWidth: '100%' });
                } else {
                    $('.default-thumbs').css({ position: 'relative', top: '0px', maxWidth: '100%' });
                    $('.default-thumbs').css({ paddingTop: '0' + 'px' });
                }
            }
        }

        window.addEventListener('scroll', function () {
            animeScroll();
        });

        animeScroll();
    }

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    if ($('.product-detail__header--photoArea-mobile')) {
        $('.product-detail__header--photoArea-mobile').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if ($('.product-rating__review-list').length) {
        $('.product-rating__review-list').slick({
            arrows: true,
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                }
            ]
        });
    }

    if ($('#product-detail-related-carrousel')) {
        $('#product-detail-related-carrousel').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            speed: 700,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                }
            ]
        });

        $('#product-detail-related-carrousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    }

    $('#photo-fancy').fancybox();

    const buyTogether = document.querySelector('.product-detail__buy-together');
    if (buyTogether && window.innerWidth <= 768) { // só mobile
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    const groups = document.querySelectorAll('[id^="js_buy_together_api_group_"]');

                    groups.forEach(group => {
                        const infoProduct = group.querySelector('.info-product');
                        const productOptions = group.querySelector('.product-item__options');

                        if (infoProduct && productOptions && productOptions.parentNode !== infoProduct) {
                            infoProduct.appendChild(productOptions); // move pro final
                        }
                    });
                }
            });
        });

        observer.observe(buyTogether, {
            childList: true,
            subtree: true
        });
    }

})